export default __webpack_public_path__ + "static/media/train-2.5d62411e.png";